'use client';
import { motion, useMotionValue, useSpring } from 'framer-motion';
import { useEffect, useRef } from 'react';

const FOLLOW_STRENGTH = 0.25;
const MAX_OFFSET_PX = 48;
const SPRING = { stiffness: 150, damping: 15 };

const clampOffset = (value: number) =>
  Math.max(-MAX_OFFSET_PX, Math.min(MAX_OFFSET_PX, value));

const ItemsValueCard = () => {
  const anchorRef = useRef<HTMLDivElement>(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const springX = useSpring(x, SPRING);
  const springY = useSpring(y, SPRING);

  // the whole black selling section drives the follow effect; offsets are
  // measured against the static anchor so the moving card doesn't feed its
  // own position back into the calculation
  useEffect(() => {
    const area = anchorRef.current?.closest<HTMLElement>(
      '[data-items-value-area]'
    );
    if (!area) return;

    const handleMouseMove = (event: globalThis.MouseEvent) => {
      const rect = anchorRef.current?.getBoundingClientRect();
      if (!rect) return;
      x.set(
        clampOffset(
          (event.clientX - (rect.left + rect.width / 2)) * FOLLOW_STRENGTH
        )
      );
      y.set(
        clampOffset(
          (event.clientY - (rect.top + rect.height / 2)) * FOLLOW_STRENGTH
        )
      );
    };
    const handleMouseLeave = () => {
      x.set(0);
      y.set(0);
    };

    area.addEventListener('mousemove', handleMouseMove);
    area.addEventListener('mouseleave', handleMouseLeave);
    return () => {
      area.removeEventListener('mousemove', handleMouseMove);
      area.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [x, y]);

  return (
    <div ref={anchorRef} className="absolute right-0 top-1/2 -translate-y-1/2">
      <motion.div
        style={{ x: springX, y: springY }}
        className="flex flex-col gap-[0.25rem] rounded-[1rem] bg-white py-[1.25rem] pl-[1.25rem] pr-[2.25rem] md:gap-[0.5rem] md:rounded-[2rem] md:py-[2.5rem] md:pl-[2.5rem] md:pr-[5rem]"
      >
        <span className="text-[1rem] font-medium leading-[1.5] text-black md:text-[2rem]">
          Items value
        </span>
        <span className="text-[2.7rem] font-bold leading-[1.1] tracking-[-0.01em] text-brand-secondary md:text-[6rem]">
          $49,609
        </span>
      </motion.div>
    </div>
  );
};

export default ItemsValueCard;
